export const CREATE_CLINIC_VACATION = "/clinic/create-vacation";
export const CREATE_DOCTOR_VACATION = "/doctor/create-vacation";
export const DELETE_CLINIC_VACATION = "/clinic/delete-vacation";
export const DELETE_DOCTOR_VACATION = "/doctor/delete-vacation";
export const EDIT_CLINIC_VACATION = "/clinic/edit-vacation";
export const EDIT_DOCTOR_VACATION = "/doctor/edit-vacation";
export const GET_CLINIC_VACATION = "/clinic/get-vacation";
export const GET_DOCTOR_VACATION = "/doctor/get-vacation";
export const GET_CLINIC_PROCEDURE = "/clinic/get-procedure";
export const GET_DOCTOR_PROCEDURE = "/doctor/get-procedure";
export const CLINIC_CHECK_AND_ADD_UPDATE_SLOTS =
  "/clinic/add-slots-by-consultation-type";
export const DOCTOR_CHECK_AND_ADD_UPDATE_SLOTS =
  "/doctor/add-slots-by-consultation-type";

export const GET_RESOURCE_PROCEDURE_LIST = (details) => {
  return `api/v1/lab/selected_resources/${details}/tests`;
};
